var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNear(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1022 3.67529L13.7858 9.42439C13.5556 9.81602 13.9964 10.2895 14.3138 9.96002L17.5778 6.64257C17.6662 6.55966 17.7895 6.62184 17.7895 6.76584V17.1306C17.7895 17.2757 17.6313 17.3378 17.5604 17.2342L7.68001 3.42766C7.36365 2.97493 6.90547 2.72729 6.39274 2.72729H6.03928C5.12292 2.72729 4.36365 3.61311 4.36365 4.70511V19.2949C4.36365 20.3858 5.12183 21.2727 6.05783 21.2727C6.63928 21.2727 7.18692 20.9226 7.50437 20.3247L10.8207 14.5757C11.0498 14.184 10.6091 13.7106 10.2916 14.04L7.02765 17.3367C6.94037 17.4197 6.81601 17.3586 6.81601 17.2135V6.86948C6.81601 6.72439 6.97528 6.6622 7.0451 6.76584L16.9255 20.5724C17.2418 21.0251 17.7196 21.2727 18.2127 21.2727H18.5662C19.5011 21.2727 20.2593 20.3869 20.2593 19.2949V4.70511C20.2593 3.6142 19.5011 2.72729 18.5662 2.72729C17.9662 2.72729 17.4196 3.07748 17.1022 3.67529Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNear);
export default __webpack_public_path__ + "static/media/near.c260651fbc0745a21bcc298744fa9ed8.svg";
export { ForwardRef as ReactComponent };